import axios from "axios";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import Modal from "../../../components/Modal/Modal";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";
import AddClosedData from "../../Closed/components/AddClosedData";


const initialData = {
  under_contract_id: "",
  property: { id: "", name: "" },
  company_gcl: "",
  contract_price: "",
  contract_cap_rate: "",
  closing_date: "",
  initial_date: "",
  contract_date: "",
};


const ConvertClosedModal = ({ showModal, onClose, onCallApi, id }) => {
  const [config] = useAuth();
  const [error, setError] = useState();
  const [disable, setDisable] = useState(false);
  const [formData, setFormData] = useState(initialData);
  const [isDollar, setIsDollar] = useState(false)
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setFormData(initialData);
    onClose();
    setError();
    setDisable(false);
  };

  useEffect(() => {
    if (id && showModal) {
      setLoading(true);
      axios
        .get(`${BASE_URL}/contract-getby-Id/${id}`, config)
        .then((res) => {
          const data = res?.data?.contract;
          setIsDollar(data?.executed?.company_gcl_type === 'dollar' ? true : false);
          setFormData({
            executed_id: data.executed_id,
            property: {
              id: data?.executed?.link?.id,
              name: data?.executed?.link?.property_name,
            },
            
            portfolio: data?.portfolio === 1 ? 1 : 0,
            company_gcl: data?.executed?.company_gcl,
            contract_price: data?.contract_price,
            contract_date: data?.created_at,
            under_contract_id: data.id,
            contract_cap_rate: data?.contract_cap_rate,
            initial_date: data.initial_list_date,
            company_gcl_type: isDollar ? "dollar" : "percent",
          });
        })
        .catch((err) => {
          if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
            NotificationManager.error(err.response?.data?.message);
          }
        })
        .finally(() => setLoading(false));
    }
  }, [id, showModal]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisable(true);
    const dataToSend = {
      portfolio: formData?.portfolio === 1 ? 1 : 0,
      under_contract_id: formData.under_contract_id,
      property: formData.property,
      company_gcl: formData.company_gcl,
      company_gcl_type: isDollar ? "dollar" : "percent",
      contract_price: formData.contract_price,
      contract_cap_rate: formData.contract_cap_rate,
      closing_date: formData.closing_date,
      initial_date: formData.initial_date,
      contract_date: formData.contract_date,
    };
    axios
      .post(`${BASE_URL}/add-close`, dataToSend, config)
      .then((res) => {
        handleClose();
        onCallApi();
      })
      .catch((err) => {
        setDisable(false);
        setError(err.response?.data?.errors);
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  return (
    <Modal title={`Convert to Closed`} desc={`Add closed information.`} show={showModal} onClose={handleClose}>
      <AddClosedData
        formData={formData}
        isDollar={isDollar}
        setIsDollar={setIsDollar}
        error={error}
        isSidebarOpen={isSidebarOpen}
        onSetFormData={(value) => {
          setFormData(value);
        }}
        onSetError={(value) => setError(value)}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
        showModal={showModal}
        disable={disable}
      />
    </Modal>
  );
};

export default ConvertClosedModal;
